export default function(x) {
  return +x;
}



//////////////////
// WEBPACK FOOTER
// ../~/d3-scale/src/number.js
// module id = FNaI
// module chunks = 0